import { Amazon } from "@winamp/icons/Amazon.js";
import { Apple } from "@winamp/icons/Apple.js";
import { Deezer } from "@winamp/icons/Deezer.js";
import { Facebook } from "@winamp/icons/Facebook.js";
import { Instagram } from "@winamp/icons/Instagram.js";
import { SnapChat } from "@winamp/icons/SnapChat.js";
import { SoundCloud } from "@winamp/icons/SoundCloud.js";
import { Spotify } from "@winamp/icons/Spotify.js";
import { Tiktok } from "@winamp/icons/Tiktok.js";
import { Twitter } from "@winamp/icons/Twitter.js";
import { Website } from "@winamp/icons/Website.js";
import { Youtube } from "@winamp/icons/Youtube.js";

interface ISocialMediaIconProps {
  value: string | undefined | null;
  type: "url" | "name";
  className?: string;
}

const socialMediaIcons = {
  amazon: Amazon,
  apple: Apple,
  deezer: Deezer,
  facebook: Facebook,
  instagram: Instagram,
  soundcloud: SoundCloud,
  snapchat: SnapChat,
  spotify: Spotify,
  tiktok: Tiktok,
  twitter: Twitter,
  youtube: Youtube,
};

type SocialMedia = keyof typeof socialMediaIcons;

export function getSocialMedia({
  value,
  type,
}: {
  value: string | undefined | null;
  type: "url" | "name";
}): SocialMedia | null {
  if (!value) return null;

  if (type === "url") {
    if (value.includes("music.amazon.com/")) {
      return "amazon";
    }
    if (value.includes("music.apple.com/")) {
      return "apple";
    }
    if (value.includes("deezer.com/")) {
      return "deezer";
    }
    if (value.includes("facebook.com/")) {
      return "facebook";
    }
    if (value.includes("instagram.com/")) {
      return "instagram";
    }
    if (value.includes("soundcloud.com/")) {
      return "soundcloud";
    }
    if (value.includes("snapchat.com/")) {
      return "snapchat";
    }
    if (value.includes("open.spotify.com/")) {
      return "spotify";
    }
    if (value.includes("tiktok.com/")) {
      return "tiktok";
    }
    if (value.includes("twitter.com/") || value.includes("x.com/")) {
      return "twitter";
    }
    if (value.includes("youtube.com/")) {
      return "youtube";
    }
  }

  if (type === "url") {
    const keys = Object.keys(socialMediaIcons) as Array<SocialMedia>;
    for (const key of keys) {
      if (value.toLowerCase().includes(key)) {
        return key;
      }
    }
  }

  return null;
}

export function SocialMediaIcon({
  value,
  type,
  className,
}: ISocialMediaIconProps) {
  const socialMedia = getSocialMedia({ value, type });
  const Icon = socialMedia ? socialMediaIcons[socialMedia] : null;
  return Icon ? (
    <Icon className={className} />
  ) : (
    <Website className={className} />
  );
}
